function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyVc2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25494_157784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8095 10.94C27.2695 14.78 23.4095 20 20.1795 22.59L18.2095 24.17C17.9595 24.35 17.7095 24.51 17.4295 24.62C17.4295 24.44 17.4195 24.24 17.3895 24.05C17.2795 23.21 16.8995 22.43 16.2295 21.76C15.5495 21.08 14.7195 20.68 13.8695 20.57C13.6695 20.56 13.4695 20.54 13.2695 20.56C13.3795 20.25 13.5495 19.96 13.7595 19.72L15.3195 17.75C17.8995 14.52 23.1395 10.64 26.9695 9.11C27.5595 8.89 28.1295 9.05 28.4895 9.42C28.8695 9.79 29.0495 10.36 28.8095 10.94Z",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4293 24.6201C17.4293 25.7201 17.0093 26.77 16.2193 27.57C15.6093 28.18 14.7793 28.6001 13.7893 28.7301L11.3293 29.0001C9.9893 29.1501 8.8393 28.01 8.9993 26.65L9.2693 24.1901C9.5093 22.0001 11.3393 20.6001 13.2793 20.5601C13.4793 20.5501 13.6893 20.56 13.8793 20.57C14.7293 20.68 15.5593 21.0701 16.2393 21.7601C16.9093 22.4301 17.2893 23.21 17.3993 24.05C17.4093 24.24 17.4293 24.4301 17.4293 24.6201Z",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2398 21.47C21.2398 18.86 19.1198 16.74 16.5098 16.74",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1207 19.73L27.8607 20.46C29.3507 21.95 29.3507 23.42 27.8607 24.91L24.9007 27.87C23.4307 29.34 21.9407 29.34 20.4707 27.87",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1103 17.5101C8.64031 16.0201 8.64031 14.5501 10.1103 13.0601L13.0703 10.1001C14.5403 8.63006 16.0303 8.63006 17.5003 10.1001L18.2403 10.8401",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2508 10.85L14.5508 14.55",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1202 19.73L24.1602 22.68",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25494_157784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(7 7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyVc2);
export default __webpack_public_path__ + "static/media/companyVc2.f4213154c78d89d37b9dd2495dac552f.svg";
export { ForwardRef as ReactComponent };